module.exports = __webpack_public_path__ + "static/media/10_Unable_to_move.b275141f.svg";